"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigValuesResponse = void 0;

var _utils = require("../../../../utils");

var _kvp = require("../models/kvp");

var getConfigValuesResponse = function getConfigValuesResponse(raw) {
  return (0, _utils.parseModel)(raw, {
    result: {
      path: 'GetConfigValuesResult[0]',
      model: _utils.genericAsResultHeader
    },
    response: {
      path: 'PropertyArray[0].Property',
      model: _kvp.keyValuePairModel
    }
  });
};

exports.getConfigValuesResponse = getConfigValuesResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/config/response-parsers/get-config-values.js
// module id = 218
// module chunks = 0